// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-b7486b8a] .active{--text-opacity:1;color:#f9a91e;color:rgba(249,169,30,var(--text-opacity))}.line[data-v-b7486b8a]{height:.2rem}.circle[data-v-b7486b8a]{height:.6rem;width:.6rem;bottom:-.2rem}@media (min-width:768px){.line-container[data-v-b7486b8a]{bottom:-.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
